var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPawn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.314,
    height: 20.097,
    viewBox: "0 0 14.314 20.097",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17450",
    "data-name": "Group 17450",
    transform: "translate(-7.843 -4.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-chess-3392448",
    transform: "translate(-192.274 -33.628)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_247970",
    "data-name": "Path 247970",
    d: "M396.191,470.374H388.48c.226-.269,1.446-1.961,1.778-7.414h4.289c0,.251-.037,4.52,1.644,7.414Z",
    transform: "translate(-184.991 -416.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247971",
    "data-name": "Path 247971",
    d: "M257.175,906.1H244.443a1.308,1.308,0,0,1,1.163-1.6,1.114,1.114,0,0,0,1.041-1.139h8.31c.244,1.12.8,1.12.8,1.12C257.484,904.594,257.245,905.838,257.175,906.1Z",
    transform: "translate(-43.526 -849.301)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247972",
    "data-name": "Path 247972",
    d: "M214.431,1082.718l-.012.985h-14.29l-.011-.836a1.259,1.259,0,0,1,.6-.581h13.2A.973.973,0,0,1,214.431,1082.718Z",
    transform: "translate(0 -1025.026)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247973",
    "data-name": "Path 247973",
    d: "M450.055,390.859a.48.48,0,0,1-.487.472h-4.681a.472.472,0,1,1,0-.944h4.681A.48.48,0,0,1,450.055,390.859Z",
    transform: "translate(-239.911 -345.511)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247974",
    "data-name": "Path 247974",
    d: "M440.7,41.615a3.035,3.035,0,1,1-3.035-3.035,3.035,3.035,0,0,1,3.035,3.035",
    transform: "translate(-230.315 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPawn);
export default __webpack_public_path__ + "static/media/pawn.bccbec2f4eab1cb6254fd4f6bb463c5f.svg";
export { ForwardRef as ReactComponent };